import {FC} from 'react'
import clsx from 'clsx'
import {KTIcon, bucketUrl, toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, ThemeModeSwitcher, BrandThemeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {useQuery} from 'react-query'
import {useKeycloak} from '@react-keycloak/web'
import {getSimpleMediumByEmail} from '../../../../app/modules/app/management/users-list/core/_requests'

const itemClass = 'ms-1 ms-lg-3',
  btnClass = 'btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px',
  userAvatarClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  const {config} = useLayout()
  const {keycloak} = useKeycloak()

  // Foto do usuário logado: o email do Keycloak é a identidade real —
  // funciona para todos os perfis (o localStorage 'key_id_medium_login'
  // guarda email para admins e ID numérico para operacionais)
  const email = keycloak?.tokenParsed?.email as string | undefined

  const {data: devas} = useQuery(
    `devas-foto-${email}`,
    () => {
      if (!email) {
        return null
      }
      return getSimpleMediumByEmail(email)
    },
    {
      onError: (err) => {
        console.error(err)
      },
    }
  )

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* begin::Brand theme */}
      <div className={clsx('d-flex align-items-center', itemClass)}>
        <BrandThemeSwitcher toggleBtnClass={btnClass} />
      </div>
      {/* end::Brand theme */}

      {/* begin::Theme mode */}
      <div className={clsx('d-flex align-items-center', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={btnClass} />
      </div>
      {/* end::Theme mode */}

      {/* begin::User */}
      <div className={clsx('d-flex align-items-center', itemClass)} id='kt_header_user_menu_toggle'>
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img
            alt='Foto'
            src={devas?.foto ? bucketUrl(devas.foto, devas.id_medium) : toAbsoluteUrl('/media/avatars/blank.png')}
          />
        </div>
        <HeaderUserMenu devas={devas || {}} />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTIcon iconName='text-align-left' className='fs-1' />
          </div>
        </div>
      )}
    </div>
  )
}

export {Topbar}
